import {useAuthStore} from "src/stores/authStore";
import WebSocketService from "src/services/webSocketService";
import AppPresenceService from "src/services/utils/appPresenceService";

export default function authHeader(type  = 'application/json') {
  const store = useAuthStore()

  const currentWsId = WebSocketService.getInstance().getCurrentWsId()

  if (store.currentUser && store.currentUser.accessToken) {
    const headers = {'x-pappus':'PAPPUS', 'ws-id': currentWsId,'x-access-token': store.currentUser.accessToken, 'Content-Type': type}
    // Présence réelle : secondes depuis la dernière interaction, uniquement si l'application est au premier plan.
    // Sans cet en-tête (arrière-plan, position GPS d'un onglet oublié), le serveur ne touche pas à la dernière connexion
    const idle = AppPresenceService.idleSeconds()
    if (idle !== null) headers['x-user-idle'] = String(idle)
    return headers
  } else if(currentWsId) {
    return {'x-pappus':'PAPPUS', 'ws-id': currentWsId}
  } else {
    return {}
  }
}
